<template>
  <app-kebab-actions>
    <div class="action">
      <CollectionInfo
        :item="item"
        @showInfo="showInfo" />
    </div>
    <div
      class="action">
      <collection-copy
        :item="item"
        :collection-id="item.id" />
    </div>
    <div class="action">
      <collection-add-to-custom-library
        :id="item.id"
        :item="item"
        :libraries-list="librariesList"
        :library-id="$route.params.id" />
    </div>
    <div
      class="action">
      <collection-btn-sharing-option
        :disabled="!(disableActions && !item.follow)" />
    </div>
    <div
      class="action">
      <CollectionDelete
        :disabled="!(disableActions && !item.follow)"
        is-library
        :item="item" />
    </div>
    <div class="action">
      <app-icon-btn
        icon-name="mdi-plus"
        :icon-height="16"
        bottom
        :access="canWorkWithAddProduct"
        show-tooltip
        @click="openCreateProductModal">
        Create Product
      </app-icon-btn>
    </div>
    <div class="action">
      <EmbedCode />
    </div>
  </app-kebab-actions>
</template>
<script>
import AppKebabActions from '@/components/App/AppKebabActions';
import { COLLECTION } from '@/constants/cores';
import CollectionDelete
  from '@/components/Collections/CollectionsActions/CollectionsActionsComponent/CollectionDelete';
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import CollectionCopy
  from '@/components/Collections/CollectionsActions/CollectionsActionsComponent/CollectionCopy';
import CollectionAddToCustomLibrary
  from '@/components/Collections/CollectionsActions/CollectionsActionsComponent/CollectionAddToCustomLibrary';
import CollectionBtnSharingOption from '@/components/Collections/CollectionBtnSharingOption';
import CollectionInfo from '@/components/Collections/CollectionsActions/CollectionsActionsComponent/CollectionInfo';
import CollectionEmbedCode from '@/components/CollectionDetails/CollectionEmbedCode';
export default {
  name: 'CollectionActionDetail',
  components: {
    CollectionBtnSharingOption,
    CollectionAddToCustomLibrary,
    CollectionCopy,
    CollectionDelete,
    CollectionInfo,
    AppKebabActions,
    EmbedCode: CollectionEmbedCode,
  },
  props: {
    item: {
      type: Object,
      default: () => null,
    },
    disableActions: {
      type: Boolean,
      default: false,
    },
    isCommunityCollections: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      COLLECTION,
    };
  },
  computed: {
    ...mapState('Libraries', ['librariesList']),
    ...mapGetters('UserRoles', ['canAddProductToCollection', 'findUserRoleInLibraryForActiveHeader']),
    listSharingName() {
      return this.item.members.map(e => e.name).join(', ');
    },
    canWorkWithAddProduct() {
      return this.canAddProductToCollection(this.findUserRoleInLibraryForActiveHeader);
    },
  },
  methods: {
    ...mapMutations(['spinner']),
    ...mapActions({
      manageSharedUser: 'Collections/manageSharedUser',
      openCreateProductModal: 'Collections/openCreateProductModal',
      showCollectionInfo: 'Collections/showCollectionInfo',
    }),
    async showInfo() {
      await this.showCollectionInfo({
        collectionId: this.item.id,
        isCommunityCollections: this.isCommunityCollections,
      });
    },
  },
};
</script>
<style scoped>
.action {
  padding: 0 !important;
}
</style>
